import Big from "big.js";
import { UseFormReturn } from "react-hook-form";
import { hachuUchiwakeKbn, tenyuryokuKbn } from "services/codes";
import { B000170Get, B000200Get } from "..";
import { catchRestError, RestClient } from "../RestClient";

export type B040010CreateRequest = {
  hachuYmd: string;
  shireCd: string;
  // 明細
  hachumeiList: B040010CreateMeiRequest[];
} & Partial<{
  nyukayoteiYmd: string;
  shireNm: string;
  otodokeCd: string;
  otodokeNm: string;
  shainCd: string;
  bumonCd: string;
  eigyoCd: string;
  bikoCd: string;
  biko: string;
}>;

export type B040010CreateMeiRequest = {
  hachugyoNo: string;
  uchiwakeKbn: string;
  shohinCd: string;
  sokoCd: string;
} & Partial<{
  shohinNm: string;
  hachusu: string;
  tenyuryokuKbn: string;
  hachutanka: string;
  hachuKin: string;
  nyukayoteiYmd: string;
  meisaibikoCd: string;
  meisaibiko: string;
  kanryoKbn: string;
}>;

export type B040010CreateResponse = {
  hachudenpyoNo: string;
};

// 発注入力登録処理メソッド
export const B040010Create = (methods: UseFormReturn, rows: any) => {
  const fields = methods.getValues();

  // マッピング
  // 明細
  const meiData: B040010CreateMeiRequest[] = rows.map((row: any) => {
    return row;
  });

  // ヘッダー
  const data: B040010CreateRequest = {
    hachuYmd: fields.hachuYmd,
    nyukayoteiYmd: fields.nyukayoteiYmd,
    shireCd: fields.shireCd,
    shireNm: fields.shireNm,
    otodokeCd: fields.otodokeCd,
    otodokeNm: fields.otodokeNm,
    shainCd: fields.shainCd,
    bumonCd: fields.bumonCd,
    eigyoCd: fields.eigyoCd,
    bikoCd: fields.bikoCd,
    biko: fields.biko,
    hachumeiList: [...meiData],
  };

  return RestClient.post<B040010CreateResponse>("b040010/create", data);
};

export type B040010UpdateRequest = {
  hachuYmd: string;
  hachudenpyoNo: string;
  shireCd: string;
  version: string;
  // 明細
  hachumeiList: B040010UpdateMeiRequest[];
} & Partial<{
  nyukayoteiYmd: string;
  shireNm: string;
  otodokeCd: string;
  otodokeNm: string;
  shainCd: string;
  bumonCd: string;
  eigyoCd: string;
  bikoCd: string;
  biko: string;
}>;

export type B040010UpdateMeiRequest = {
  hachugyoNo: string;
  uchiwakeKbn: string;
  shohinCd: string;
  sokoCd: string;
} & Partial<{
  shohinNm: string;
  hachusu: string;
  tenyuryokuKbn: string;
  hachutanka: string;
  hachuKin: string;
  nyukayoteiYmd: string;
  meisaibikoCd: string;
  meisaibiko: string;
  kanryoKbn: string;
}>;

// 発注入力更新処理メソッド
export const B040010Update = (methods: UseFormReturn, rows: any) => {
  const fields = methods.getValues();

  // マッピング
  // 明細
  const meiData: B040010UpdateMeiRequest[] = rows.map((row: any) => {
    return row;
  });

  // ヘッダー
  const data: B040010UpdateRequest = {
    hachudenpyoNo: fields.hachudenpyoNo,
    hachuYmd: fields.hachuYmd,
    nyukayoteiYmd: fields.nyukayoteiYmd,
    shireCd: fields.shireCd,
    shireNm: fields.shireNm,
    otodokeCd: fields.otodokeCd,
    otodokeNm: fields.otodokeNm,
    shainCd: fields.shainCd,
    bumonCd: fields.bumonCd,
    eigyoCd: fields.eigyoCd,
    bikoCd: fields.bikoCd,
    biko: fields.biko,
    version: fields.version,
    hachumeiList: [...meiData],
  };

  return RestClient.put("b040010/update", data);
};

export type B040010DeleteRequest = Partial<{
  hachudenpyoNo: string;
}>;

// 発注入力削除メソッド
export const B040010Delete = (props: B040010DeleteRequest) => {
  return RestClient.delete("b040010/delete", { data: props });
};

export type B040010GetShainRequest = {
  shainCd: string;
};

export type B040010GetShainResponse = {
  shainNm: string;
  bumonCd: string;
  bumonNm: string;
  eigyoCd: string;
  sokoCd: string;
  sokoNm: string;
  sokoshubetsuKbn: string;
};

export const B040010GetShain = (props: B040010GetShainRequest) => {
  return RestClient.get<B040010GetShainResponse>("b040010/get/shain", {
    params: props,
  });
};

// 仕入先表示
export const B040010Shire = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  if (!fields.shireCd) {
    methods.setValue("shireNm", "");
    methods.setValue("shainCd", "");
    methods.setValue("shainNm", "");
    methods.setValue("bumonCd", "");
    methods.setValue("bumonNm", "");
    methods.setValue("eigyoCd", "");
    methods.setValue("defaultSokoCd", "");
    methods.setValue("defaultSokoNm", "");
    methods.setValue("defaultSokoshubetsuKbn", "");
    methods.setValue("shireShokuchiKbn", "");
    return;
  }
  await B000170Get({ shireCd: fields.shireCd })
    .then((response) => {
      methods.setValue("shireNm", response.data.shireNmr ?? "");
      methods.setValue("shainCd", response.data.shainCd ?? "");
      methods.setValue("shainNm", response.data.shainNm ?? "");
      methods.setValue("shireShokuchiKbn", response.data.shokuchiKbn ?? "");
      // 社員関連項目取得
      B040010Shain(methods, navigate, setMsg);
    })
    .catch((reason) => {
      // 返却値が存在しない場合
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shireNm", "");
      methods.setValue("shainCd", "");
      methods.setValue("shainNm", "");
      methods.setValue("bumonCd", "");
      methods.setValue("bumonNm", "");
      methods.setValue("eigyoCd", "");
      methods.setValue("defaultSokoCd", "");
      methods.setValue("defaultSokoNm", "");
      methods.setValue("defaultSokoshubetsuKbn", "");
      methods.setValue("shireShokuchiKbn", "");
    });
};

// 社員関連項目取得処理メソッド
export const B040010Shain = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  if (!fields.shainCd) {
    methods.setValue("shainNm", "");
    methods.setValue("bumonCd", "");
    methods.setValue("bumonNm", "");
    methods.setValue("eigyoCd", "");
    methods.setValue("defaultSokoCd", "");
    methods.setValue("defaultSokoNm", "");
    methods.setValue("defaultSokoshubetsuKbn", "");
    return;
  }
  await B040010GetShain({ shainCd: fields.shainCd })
    .then((response) => {
      methods.setValue("shainNm", response.data.shainNm ?? "");
      methods.setValue("bumonCd", response.data.bumonCd ?? "");
      methods.setValue("bumonNm", response.data.bumonNm ?? "");
      methods.setValue("eigyoCd", response.data.eigyoCd ?? "");
      methods.setValue("defaultSokoCd", response.data.sokoCd ?? "");
      methods.setValue("defaultSokoNm", response.data.sokoNm ?? "");
      methods.setValue(
        "defaultSokoshubetsuKbn",
        response.data.sokoshubetsuKbn ?? ""
      );
    })
    .catch((reason) => {
      // 返却値が存在しない場合
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shainNm", "");
      methods.setValue("bumonCd", "");
      methods.setValue("bumonNm", "");
      methods.setValue("eigyoCd", "");
      methods.setValue("defaultSokoCd", "");
      methods.setValue("defaultSokoNm", "");
      methods.setValue("defaultSokoshubetsuKbn", "");
    });
};

//消費税取得処理リクエスト
export type B040010GetZeiRitsuRequest = {
  kijunYmd: string;
};

//消費税取得処理レスポンス
export type B040010GetZeiRitsuResponse = {
  zeiRitsu: string;
};

export const B040010GetZeiRitsu = (props: B040010GetZeiRitsuRequest) => {
  return RestClient.get<B040010GetZeiRitsuResponse>("b010010/get/shohizei", {
    params: props,
  });
};

//消費税取得処理メソッド
export const B040010ZeiRitsu = async (methods: UseFormReturn) => {
  const fields = methods.getValues();
  if (!fields.hachuYmd) {
    return;
  }
  await B040010GetZeiRitsu({ kijunYmd: fields.hachuYmd }).then((response) => {
    methods.setValue("zeiRitsu", response.data.zeiRitsu ?? "");
  });
};

export type B040010GetShohinRequest = {
  shohinCd: string;
  hachuYmd: string;
};

export type B040010GetShohinResponse = {
  shohinNm: string;
  shohinshokuchiKbn: string;
  hachutanka: string;
};

export const B040010GetShohin = (props: B040010GetShohinRequest) => {
  return RestClient.get<B040010GetShohinResponse>("b040010/get/shohin", {
    params: props,
  });
};

// 商品関連項目表示メソッド
export const B040010Shohin = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  const meiFields = meiMethods.getValues();
  if (meiFields.shohinCd === "") {
    meiMethods.setValue("shohinNm", "");
    meiMethods.setValue("shohinShokuchiKbn", "");
    meiMethods.setValue("tenyuryokuKbn", "");
    meiMethods.setValue("basetanka", "");
    meiMethods.setValue("hachutanka", "");
    meiMethods.setValue("sokoCd", "");
    meiMethods.setValue("sokoNm", "");
    return;
  }
  // 商品名表示
  await B040010GetShohin({
    shohinCd: meiFields.shohinCd,
    hachuYmd: fields.hachuYmd,
  })
    .then((response) => {
      meiMethods.setValue("shohinNm", response.data.shohinNm ?? "");
      meiMethods.setValue(
        "shohinShokuchiKbn",
        response.data.shohinshokuchiKbn ?? ""
      );
      meiMethods.setValue("sokoCd", fields.defaultSokoCd ?? "");
      meiMethods.setValue("sokoNm", fields.defaultSokoNm ?? "");
      meiMethods.setValue(
        "sokoshubetsuKbn",
        fields.defaultSokoshubetsuKbn ?? ""
      );

      // uchiwakeKbn が 2 以外の場合
      if (meiFields.uchiwakeKbn.value !== hachuUchiwakeKbn.nebiki) {
        // uchiwakeKbn が3の場合
        if (meiFields.uchiwakeKbn.value === hachuUchiwakeKbn.mihon) {
          // basetanka , hachutanka に0を設定する。
          meiMethods.setValue("basetanka", "0");
          meiMethods.setValue("hachutanka", "0");

          // 発注金額再設定
          meiMethods.setValue("hachuKin", "0");
        } else {
          // basetanka , hachutanka に設定する。
          meiMethods.setValue("basetanka", response.data.hachutanka ?? "");
          meiMethods.setValue("hachutanka", response.data.hachutanka ?? "");

          // 発注金額再計算
          if (meiFields.hachusu === "") {
            meiMethods.setValue("hachuKin", "");
          } else {
            // hachuKin に設定する。hachusu × hachutanka
            const calcHachuKin: Big = new Big(meiFields.hachusu!)
              .times(new Big(response.data.hachutanka))
              .round(0, Big.roundDown);
            meiMethods.setValue("hachuKin", calcHachuKin.toString());
          }
        }
        // tenyuryokuKbn に 0(なし)を設定する。
        meiMethods.setValue("tenyuryokuKbn", tenyuryokuKbn.none);
      }
    })
    .catch((reason) => {
      // 返却値が存在しない場合
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("basetanka", "");
      meiMethods.setValue("hachutanka", "");
      meiMethods.setValue("hachuKin", "");
    });
};

// 商品コード変更メソッド
export const B040010HandleChangeShohinCd = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  // 変更されていない場合は切替しない。
  if (!meiMethods.getFieldState("shohinCd").isDirty) {
    return;
  }

  const meiFields = meiMethods.getValues();
  if (meiFields.shohinCd === "") {
    meiMethods.setValue("shohinNm", "");
    meiMethods.setValue("shohinShokuchiKbn", "");
    meiMethods.setValue("tenyuryokuKbn", "");
    meiMethods.setValue("basetanka", "");
    meiMethods.setValue("hachutanka", "");
    meiMethods.setValue("hachuKin", "");
    return;
  }
  // 商品名表示
  await B000200Get({ shohinCd: meiFields.shohinCd })
    .then((response) => {
      meiMethods.setValue("shohinNm", response.data.shohinNm ?? "");
      meiMethods.setValue("shohinShokuchiKbn", response.data.shokuchiKbn ?? "");
      // 値を保持
      meiMethods.unregister("shohinCd", { keepValue: true });

      // 商品関連項目設定処理
      B040010Shohin(methods, meiMethods, navigate, setMsg);
    })
    .catch((reason) => {
      // 返却値が存在しない場合
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("shohinNm", "");
      meiMethods.setValue("shohinShokuchiKbn", "");
      meiMethods.setValue("basetanka", "");
      meiMethods.setValue("hachutanka", "");
      meiMethods.setValue("hachuKin", "");
    });
};

// 単価取得メソッド
export const B040010Tanka = async (
  methods: UseFormReturn,
  shohinCd: string,
  rows: any,
  navigate: Function,
  setMsg: Function,
  setRows: Function
) => {
  const fields = methods.getValues();
  // 商品名表示
  await B040010GetShohin({
    shohinCd: shohinCd,
    hachuYmd: fields.hachuYmd,
  })
    .then((response) => {
      for (const row of rows) {
        // 商品コードが一致しない場合、何もしない
        if (shohinCd !== row.shohinCd) continue;
        // 単価が編集されている場合、何もしない
        if (row.tenyuryokuKbn === tenyuryokuKbn.exists) continue;

        // basetanka , hachutanka に設定する。
        row.basetanka = response.data.hachutanka;
        row.hachutanka = response.data.hachutanka;

        const calcHachuKin: Big = new Big(row.hachusu!)
          .times(new Big(row.hachutanka!))
          .round(0, Big.roundDown);
        row.hachuKin = calcHachuKin.toString();
      }
      // 明細に反映
      setRows([...rows]);
    })
    .catch((reason) => {
      // 返却値が存在しない場合
      methods.setValue("hachuYmd", "");
      catchRestError(reason, navigate, setMsg);
    });
};
